import React, { useState, useEffect } from "react";
import Header from "../../dashboard/header";
import { Link } from "react-router-dom";
import { Table, Modal, Button } from "react-bootstrap";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSortAmountUp,
  FaSortAmountDown,
  FaTools,
  FaBoxes,
  FaCheck,
} from "react-icons/fa";
import Navbar from "../../dashboard/navbar";
import { useLocation, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Sidebar from "../../dashboard/sidebar";
import useAuth from "../../dashboard/useAuth";
import axios from "axios";

const Liste_categorie = ({ titre }) => {
  useAuth();
  const [categories, setCategories] = useState([]);
  const [categorieData, setCategorieData] = useState({});
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [selectedCategorie, setSelectedCategorie] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "ascending",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const location = useLocation();
  const [descriptionOverflows, setDescriptionOverflows] = useState({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [nom, setNom] = useState("");
  const [description, setDescription] = useState("");
  const [prix, setPrix] = useState("");
  const [statut, setStatut] = useState("actif");
  const [type, setType] = useState("Article");
  const [photo, setPhoto] = useState(null);

  const user_id = localStorage.getItem("IDDDD");
  const navigate = useNavigate();

  // Utilisation de useEffect pour mettre à jour le titre de la page
  useEffect(() => {
    if (user_id) {
      document.title = "PayMe | Categorie"; // Définit le titre de la page
    }
  }, [user_id]);

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_HOTE + "/liste-categorie/"
      );
      if (response.ok) {
        const data = await response.json();
        setCategories(data);
      } else {
        console.error("Erreur lors de la récupération des categories");
      }
    } catch (error) {
      console.error("Erreur réseau:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: "", type: "" });
      fetchCategories();
    }, 3000);
  };

  const handleRowClick = (categorie) => {
    setSelectedCategorie(categorie);
  };

  const handleDeleteCategorie = async () => {
    if (selectedCategorie) {
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE +
            `/supprimer-categorie/${selectedCategorie.id}/`,
          {
            method: "DELETE",
          }
        );

        if (response.ok) {
          // Mettre à jour la liste des categories localement
          setCategories(
            categories.filter(
              (categorie) => categorie.id !== selectedCategorie.id
            )
          );

          // Stocker le message de succès dans le localStorage avant la redirection
          showAlert("Categorie supprimé avec succès !");
        } else {
          console.error("Erreur lors de la suppression du categorie");
        }
      } catch (error) {
        console.error("Erreur réseau:", error);
      } finally {
        setShowDeleteModal(false);
        setSelectedCategorie(null);
      }
    }
  };

  const checkDescriptionOverflow = (categories) => {
    categories.forEach((categorie) => {
      const element = document.getElementById(`description-${categorie.id}`);
      if (element) {
        setDescriptionOverflows((prev) => ({
          ...prev,
          [categorie.id]: element.scrollHeight > element.clientHeight,
        }));
      }
    });
  };

  useEffect(() => {
    checkDescriptionOverflow(categories);
  }, [categories]);

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Utiliser useEffect pour récupérer et afficher le message après redirection
  useEffect(() => {
    const successMessage = localStorage.getItem("successMessage");
    if (successMessage) {
      // Afficher le message (par exemple via une alerte ou un composant de notification)
      showAlert(successMessage);

      // Supprimer le message du localStorage après l'affichage
      localStorage.removeItem("successMessage");
    }
  }, []);

  const filteredCategories = categories.filter(
    (categorie) =>
      categorie.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      categorie.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      categorie.ajoute_par.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedCategories = [...filteredCategories].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  const indexOfLastCategorie = currentPage * itemsPerPage;
  const indexOfFirstCategorie = indexOfLastCategorie - itemsPerPage;
  const currentCategories = sortedCategories.slice(
    indexOfFirstCategorie,
    indexOfLastCategorie
  );
  const totalPages = Math.ceil(sortedCategories.length / itemsPerPage);
  const totalItems = categories.length; // Si 'formationList' contient toutes les formations

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handleToggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleModifier = (categorie) => {
    if (categorie) {
      setCategorieData({
        id: categorie.id,
        nom: categorie.nom,
        description: categorie.description,
      });
      setShowEditModal(true);
    }
  };

  const [accesGroupe, setAccesGroupe] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem("groupe");

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem("groupe");
    const accesGroupeStored = localStorage.getItem("accesGroupe");

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupe(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
        );
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces
              .map((item) =>
                item.acces
                  ? item.acces
                      .replace(/[\[\]']/g, "")
                      .trim()
                      .split(",")
                      .map((access) => access.trim())
                  : []
              )
              .flat();

            setAccesGroupe(cleanedAccessArray);
          }

          localStorage.setItem("groupe", data.groupe);
          localStorage.setItem(
            "accesGroupe",
            JSON.stringify(cleanedAccessArray)
          );
        }
      } catch (error) {
        // console.error('Erreur lors de la vérification du groupe', error);
      }
    }
  };

  useEffect(() => {
    if (user_id) {
      verifGroupe();
    }
  }, [user_id]);

  if (!accesGroupe.includes("Categories")) {
    return null;
  }

  const handleShowAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);

  const handleFileChange = (e) => {
    setPhoto(e.target.files[0]);
  };

  const handleCancel = () => {
    setNom("");
    setDescription("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_HOTE}/ajouter-categorie/${user_id}/`,
        {
          nom: nom,
          description: description,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (response.status === 201) {
        showAlert("Catégorie ajoutée avec succès !");
        fetchCategories();
        handleCloseAddModal();
        setNom("");
        setDescription("");
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout de la catégorie:", error.response?.data || error.message);
      showAlert(
        error.response?.data?.error || "Erreur lors de l'ajout de la catégorie",
        "danger"
      );
    }
  };

  const handleCloseEditModal = () => setShowEditModal(false);

  const handleEditReset = () => {
    if (selectedCategorie) {
      setCategorieData({
        id: selectedCategorie.id,
        nom: selectedCategorie.nom,
        description: selectedCategorie.description,
      });
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    try {
        const response = await axios.put(
            `${process.env.REACT_APP_HOTE}/modifier-categorie/${categorieData.id}/`,
            {
                nom: categorieData.nom,
                description: categorieData.description
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200) {
            showAlert("Catégorie modifiée avec succès !");
            fetchCategories();
            handleCloseEditModal();
        }
    } catch (error) {
        console.error("Erreur lors de la modification:", error.response?.data || error.message);
        showAlert(
            error.response?.data?.error || "Erreur lors de la modification", 
            "danger"
        );
    }
};

  return (
    <div id="wrapper">
          <Sidebar user_id={user_id} titre={titre} />
          <div id="page-wrapper" className="gray-bg">
            <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex align-items-center">
                <FaBoxes size={25} className="mr-2" /> Gestion des catégories
              </h2>
              <small>Administration des catégories.</small>

              <small id="hbreadcrumb" className="d-flex justify-content-end">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    {/* Utiliser Link de react-router-dom pour la navigation */}
                    <Link to={`/admin`}> Administration</Link>
                  </li>
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    {/* Utiliser Link de react-router-dom pour la navigation */}
                    <small> catégories</small>
                  </li>
                </ol>
              </small>
            </div>
          </div>
          {/* <Header titre="Categories" sous_titre="Dashboard"  sous_titre1={<Link to={`/admin`} className='text-dark'>Administration</Link>} entete="Categories" user_id={user_id} /> */}
          <div className=" mt-3">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
              <h5>Liste des catégories</h5>
              <div
                className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0"
                style={{ gap: "10px" }}
              >
                <div className="d-flex">
                  <button
                    onClick={handleShowAddModal}
                    className="btn btn-success mr-2"
                  >
                    <FaPlus /> Ajouter
                  </button>
                  <button
                    onClick={() => handleModifier(selectedCategorie)}
                    className={`btn ${
                      selectedCategorie
                        ? "btn-success"
                        : "btn-default text-dark"
                    }`}
                    disabled={!selectedCategorie}
                  >
                    <FaEdit /> Modifier
                  </button>
                </div>
                <div className="d-flex">
                  <button
                    onClick={handleShowDeleteModal}
                    className={`btn ${
                      selectedCategorie
                        ? "btn-success"
                        : "btn-default text-dark"
                    }`}
                    disabled={!selectedCategorie}
                  >
                    <FaTrash /> Supprimer
                  </button>
                </div>
              </div>
            </div>

            {alert.message && (
              <div className={`alert alert-${alert.type}`}>{alert.message}</div>
            )}

            <div className="row">
              <div className="col-lg-12">
                <div className="ibox">
                  <div className="ibox-content">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <select
                        id="itemsPerPage"
                        value={itemsPerPage}
                        onChange={(e) => {
                          setItemsPerPage(Number(e.target.value));
                          setCurrentPage(1); // Réinitialiser à la première page
                        }}
                        className="form-select bg-default p-1"
                        style={{
                          width: "auto",
                          border: "1px black solid",
                          borderRadius: "5px",
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </select>
                      <input
                        type="text"
                        placeholder="Rechercher..."
                        className="form-control"
                        style={{ maxWidth: "150px", width: "100%" }} // Largeur fixe ou maximale selon besoin
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <div className="table-responsive">
                      <table
                        className="footable table table-stripped footable-loaded tablet breakpoint"
                        data-page-size="8"
                        data-filter="#filter"
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell"
                              onClick={() => handleSort("nom")}
                              style={{ width: "15%", minWidth: "100px" }}
                            >
                              Nom
                              {sortConfig.key === "nom"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell"
                              onClick={() => handleSort("description")}
                              style={{ width: "50%", minWidth: "200px" }}
                            >
                              Description{" "}
                              {sortConfig.key === "description"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                            <th
                              className="text-secondary text-wrap d-none d-md-table-cell"
                              onClick={() => handleSort("ajoute_par")}
                              style={{ width: "15%", minWidth: "100px" }}
                            >
                              Ajouté par{" "}
                              {sortConfig.key === "ajoute_par"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentCategories.map((categorie) => {
                            return (
                              <tr
                                key={categorie.id}
                                onClick={() => handleRowClick(categorie)}
                                className={`bg-white ${
                                  selectedCategorie &&
                                  selectedCategorie.id === categorie.id
                                    ? "bg-success text-white"
                                    : ""
                                }`}
                              >
                                <td>
                                  {categorie.nom}
                                  <div className="lesInfos">
                                    <small>
                                      Description :{" "}
                                      <small
                                        dangerouslySetInnerHTML={{
                                          __html: categorie.description,
                                        }}
                                      ></small>
                                    </small>
                                    <br />
                                    <small>
                                      Ajouté par : {categorie.ajoute_par}
                                    </small>
                                  </div>
                                </td>
                                <td
                                  className="d-none d-md-table-cell"
                                  style={{ position: "relative" }}
                                >
                                  <div
                                    id={`description-${categorie.id}`}
                                    className={`description-text ${
                                      expandedDescriptions[categorie.id]
                                        ? "expanded"
                                        : ""
                                    }`}
                                    style={{
                                      maxHeight: expandedDescriptions[
                                        categorie.id
                                      ]
                                        ? "none"
                                        : "3em",
                                      overflow: "hidden",
                                      whiteSpace: "pre-wrap",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: categorie.description,
                                    }}
                                  />
                                  {descriptionOverflows[categorie.id] && (
                                    <button
                                      onClick={() =>
                                        handleToggleDescription(categorie.id)
                                      }
                                      style={{
                                        background: "none",
                                        border: "none",
                                        color: "black",
                                        cursor: "pointer",
                                        padding: 0,
                                      }}
                                    >
                                      {expandedDescriptions[categorie.id]
                                        ? "Voir moins"
                                        : "Voir plus..."}
                                    </button>
                                  )}
                                </td>
                                <td className="d-none d-md-table-cell">
                                  {categorie.ajoute_par}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div
                        className="dataTables_info"
                        role="status"
                        aria-live="polite"
                      >
                        {totalItems === 0
                          ? "Aucun élément à afficher"
                          : `Élément ${
                              currentPage === 1
                                ? 1
                                : (currentPage - 1) * itemsPerPage + 1
                            } à ${
                              currentPage * itemsPerPage > totalItems
                                ? totalItems
                                : currentPage * itemsPerPage
                            } sur ${totalItems}`}
                      </div>

                      <div>
                        {Array.from({ length: totalPages }, (_, index) => (
                          <button
                            key={index + 1}
                            onClick={() => setCurrentPage(index + 1)}
                            className={`btn ${
                              currentPage === index + 1
                                ? "btn-default"
                                : "btn-light"
                            } mx-1`}
                          >
                            {index + 1}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal d'ajout de categorie */}
            <Modal show={showAddModal} onHide={handleCloseAddModal} size="100%">
              <Modal.Header>
                <Modal.Title>Ajouter une catégorie</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form
                  className="m-t"
                  role="form"
                  onSubmit={handleSubmit}
                  encType="multipart/form-data"
                >
                  <div className="form-group">
                    <label>Nom*</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Entrez le nom"
                      required
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Description*</label>
                    <ReactQuill
                      theme="snow"
                      value={description}
                      onChange={setDescription}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ["bold", "italic", "underline", "strike"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          ["link", "image"],
                          ["clean"],
                        ],
                      }}
                      style={{ height: "200px", marginBottom: "80px" }}
                      className="custom-quill-editor"
                    />
                  </div>
                  <div className="text-right mt-4">
                    <button
                      type="button"
                      className="btn btn-default mr-2"
                      onClick={handleCloseAddModal}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-success">
                      Enregistrer
                    </button>
                  </div>
                </form>
              </Modal.Body>
            </Modal>

            <Modal
              show={showEditModal}
              onHide={handleCloseEditModal}
              size="100%"
            >
              <Modal.Header>
                <Modal.Title>Modifier la catégorie</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form className="m-t" role="form" onSubmit={handleEditSubmit}>
                  <div className="row">
                    <div className="form-group col-12 col-md-12">
                      <label>Nom*</label>
                      <input
                        type="text"
                        className="form-control"
                        required
                        value={categorieData.nom}
                        onChange={(e) =>
                          setCategorieData({
                            ...categorieData,
                            nom: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group col-12 col-md-12">
                      <label>Description*</label>
                      <ReactQuill
                        theme="snow"
                        value={categorieData.description}
                        onChange={(value) =>
                          setCategorieData({
                            ...categorieData,
                            description: value,
                          })
                        }
                        modules={{
                          toolbar: [
                            [{ header: [1, 2, false] }],
                            ["bold", "italic", "underline", "strike"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            ["link", "image"],
                            ["clean"],
                          ],
                        }}
                        style={{ height: "200px", marginBottom: "50px" }}
                      />
                    </div>
                  </div>
                  <div className="text-center mt-5">
                    <button
                      type="button"
                      className="btn btn-default mr-2"
                      onClick={handleCloseEditModal}
                    >
                      Annuler
                    </button>
                    <button
                      type="button"
                      className="btn btn-default mr-2"
                      onClick={handleEditReset}
                    >
                      Effacer
                    </button>
                    <button type="submit" className="btn btn-success">
                      Enregistrer
                    </button>
                  </div>
                </form>
              </Modal.Body>
            </Modal>

            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
              <Modal.Header>
                <Modal.Title>Confirmer la Suppression</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Êtes-vous sûr de vouloir supprimer cette catégorie{" "}
                <strong>{selectedCategorie?.nom}</strong> ?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                  Annuler
                </Button>
                <Button variant="success" onClick={handleDeleteCategorie}>
                  Supprimer
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Liste_categorie;
